import React, { useState, useCallback, useMemo } from 'react';
import PropTypes from 'prop-types';

import InlineTextEditor from '../../InlineTextEditor';
import {
  FlexRow,
  EditButton,
  BoxedEditPen,
} from './styles';

export const tenDigitValidator = value => (
  [/^\d{10}$/.test(value), 'Phone number must be ten digits']
);

export const useEditPhoneNumber = (setPhoneNumber, onChange, setIsEditing) => (
  useCallback((completed, v) => {
    if (completed) {
      setPhoneNumber(v);
      onChange(v);
    }
    setIsEditing(false);
  }, [onChange])
);

export const usePrettyNumber = phoneNumber => useMemo(() => {
  const areaCode = phoneNumber.substring(0, 3);
  const first3 = phoneNumber.substring(3, 6);
  const last4 = phoneNumber.substring(6);

  return `(${areaCode}) ${first3}-${last4}`;
}, [phoneNumber]);

const TextOptInNumberEditor = ({ number, onChange }) => {
  const [phoneNumber, setPhoneNumber] = useState(number);
  const [isEditing, setIsEditing] = useState(false);

  const editPhoneNumber = useEditPhoneNumber(setPhoneNumber, onChange, setIsEditing);

  const prettyNumber = usePrettyNumber(phoneNumber);

  return (
    <FlexRow>
      <span style={{ marginRight: '1em' }}>We&apos;ll text you at </span>
      {!isEditing && (
      <React.Fragment>
        <strong>{prettyNumber}</strong>
        <EditButton id="phoneNumberEditButton" tabIndex="0" role="button" onClick={() => setIsEditing(true)}>
          <BoxedEditPen />
        </EditButton>
      </React.Fragment>
      )}
      {isEditing && (
        <InlineTextEditor
          id="phoneNumberEditor"
          value={phoneNumber}
          onComplete={editPhoneNumber}
          validator={tenDigitValidator}
          maxLength={10}
        />
      )}
    </FlexRow>
  );
};
TextOptInNumberEditor.propTypes = {
  number: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default TextOptInNumberEditor;
